export default __webpack_public_path__ + "static/media/groupBuyingDiscountChinese.3edd8a00.png";